<template>
  <div>
    <b-row class="px-2">
      <b-col class="col-md-4">
        <AppSearchInput
          :label="$t('search') + ':'"
          :placeholder="$t('search')"
          @callback="search"
        />
      </b-col>

      <b-col class="col-md-7 text-right ml-auto">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          v-b-modal.modal-add-child-works
          style="margin-top: 18px"
          variant="primary"
        >
          <feather-icon icon="PlusIcon" size="16" />
          {{ $t("add") }}
        </b-button>
      </b-col>
    


      <b-col class="col-md-12">
        <b-table
          class="border"
          :fields="fields"
          :items="GET_ALL_BRIGADE_WORKS.results"
          show-empty
          hover
          responsive
          :empty-text="$t('empty_text')"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>
  
          <template #cell(unity)="props">
            <span>{{ getUnityTitle(props.item.unity) }}</span>
          </template>

          <template #cell(title)="props">
            <span>{{ props.item.title[$i18n.locale] }}</span>
          </template>

          <template #cell(actions)="props">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              v-b-modal.modal-add-child-works
              size="sm"
              class="ml-2 mt-50 mb-50"
              variant="warning"
              @click="editData = props.item"
            >
              <feather-icon
                icon="EditIcon"
                size="15"
              />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              variant="danger"
              class="ml-50 mt-50 mb-50"
              @click="deleteWork(props)"
            >
              <feather-icon icon="TrashIcon" size="15" />
            </b-button>
          </template>
        </b-table>

        <Pagination class="mt-2" :rows="GET_ALL_BRIGADE_WORKS.count" @refresh="refresh" :params="filtered" :nobody="nobody" />
      </b-col>
    </b-row>

    <addChildWorksModal :edit-data="editData" @save="refresh" />

  </div>
</template>

<script>
import { BButton, BCol, BRow, BTable } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import AppSearchInput from "@/components/AppSearchInput.vue";
import Pagination from "@/components/Pagination.vue";
import areYouSure from "@/mixins/areYouSure";
import addChildWorksModal from "./modals/addChildWorks.vue";


export default {
  components: {
    BButton,
    BTable,
    BCol,
    BRow,
    Pagination,
    AppSearchInput,
    addChildWorksModal,
  },
  directives: {
    Ripple,
  },
  mixins: [areYouSure],
  props: {
    
  },
  data() {
    return {




      // ===============  PRIMARY_DATA_SECTION END ===============
      nobody: true,
      filtered: {
        page: 1,
        page_size: 10,
        search: "",
      },
      editData: {ru: '', uz: ''},
      // ===============  PRIMARY_DATA_SECTION END ===============



      


      // ===============  OTHERS_SECTION END ===============
      fields: [
        {
          label: "№",
          key: "id",
        },
        {
          label:'namee',
          key: "title",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label:'unit_of_measurement',
          key: "unity",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: 'actions',
          key: "actions",
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
      // ===============  OTHERS_SECTION END ===============




    };
  },
  computed: {
    ...mapGetters("brigadeWorks", ["GET_ALL_BRIGADE_WORKS"]),
    ...mapGetters("characterUnits", ["GET_UNITS"]),



  },
  async mounted() {



    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.refresh();
    await this.FETCH_UNITS({page_size: 1000})
    // ===============  PRIMARY_REQUESTS_SECTION START ===============



  },
  methods: {
    ...mapActions("obectsWarehouse", [
      "FETCH_WAREHOUSE_ID",
      "DELETE_USERS_PINNED",
      "UPDATE_WAREHOUSE",
      "FETCH_WAREHOUSE_LEFT_TABLE",
    ]),
    ...mapActions("brigadeWorks", [
      "FETCH_ALL_BRIGADE_WORKS",
      "DELETE_BRIGADE_WORKS"
    ]),
    ...mapActions("characterUnits", ["FETCH_UNITS"]),






    // ===============  DELETE_SECTION START ===============
    deleteWork(props) {
      this.$_showAreYouSureModal().then((val) => {
        if (val) {
          console.log(props)
          this.DELETE_BRIGADE_WORKS(props.item.id)
            .then(() => {
              this.refresh();
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },
    // ===============  DELETE_SECTION END ===============






    // ===============  FILTER_SECTION START ===============
    search(text) {
      if(this.$route.query.category){
        this.filtered.search = text;
        this.FETCH_ALL_BRIGADE_WORKS({...this.filtered, category: this.$route.query.category})
      }
    },
    // ===============  FILTER_SECTION END ===============






    // ===============  REFRESH_SECTION START ===============
    refresh() {
      if(this.$route.query.category){
        this.FETCH_ALL_BRIGADE_WORKS({  ...this.filtered, category: this.$route.query.category})
      }
    },
    // ===============  REFRESH_SECTION END ===============






    // ===============  OTHERS_SECTION START ===============
    getUnityTitle(unity) {
      let unityFound = this.GET_UNITS.results.find(elem => elem.id == unity)
      return unityFound && unityFound.title ? unityFound.title : ''
    },
    // ===============  OTHERS_SECTION END ===============









  },
};
</script>
